import React, { useState, useEffect } from "react";
import EditPopup from "../../components/EditPopup/EditPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit ,faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { updateEmail, updateContactNumber, getUserDetails } from "../../api/axios";
import Alert from "../../components/common/Alert";

const EditEmail= ({ userDetails, GetUserDetails, userId ,handleBackClick}) => {
  const [isEmailPopupVisible, setIsEmailPopupVisible] = useState(false);
  const [isContactPopupVisible, setIsContactPopupVisible] = useState(false);

  const [email, setEmail] = useState("example@example.com");
  const [contactNumber, setContactNumber] = useState("123-456-7890");

  // State for managing alerts
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    if (userDetails?.registerResult) {
      setEmail(userDetails.registerResult.email || "example@example.com");
      setContactNumber(userDetails.registerResult.contactNumber || "123-456-7890");
    }
  }, [userDetails]);

  const handleEditClick = (type) => {
    if (type === "email") {
      setIsEmailPopupVisible(true);
    } else if (type === "contact") {
      setIsContactPopupVisible(true);
    }
  };

  const handleSaveEmail = async (newEmail) => {
    try {
      const updatedUser = await updateEmail(userId, newEmail.email);
      if (updatedUser) {
        setEmail(newEmail.email);
        GetUserDetails();
        setAlertMessage("Email updated successfully!");
        setAlertSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      setAlertMessage("Failed to update email.");
      setAlertSeverity("error");
      setOpenSnackbar(true);
    }
    setIsEmailPopupVisible(false);
  };

  const handleSaveContact = async (newContact) => {
    try {
      const updatedUser = await updateContactNumber(userId, newContact.contactNumber);
      if (updatedUser) {
        setContactNumber(newContact.contactNumber);
        GetUserDetails();
        setAlertMessage("Contact number updated successfully!");
        setAlertSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      setAlertMessage("Failed to update contact number.");
      setAlertSeverity("error");
      setOpenSnackbar(true);
    }
    setIsContactPopupVisible(false);
  };

  const handleClosePopup = () => {
    setIsEmailPopupVisible(false);
    setIsContactPopupVisible(false);
  };


  return (
    <div className="info-card"
     style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      >
      <div className="contact-info">
      <FontAwesomeIcon
          icon={faArrowLeft}
          className="backIcon"
          onClick={handleBackClick}
        />
      <h2 className="contact-title">Edit Contact Information</h2>
        <p className="contact-subtext">
          This will only be visible to you and in your child's Comp Card.
        </p>
        <div className="log-contact-option">
          <div className="log-contact-label"
           style={{
              fontSize: window.innerWidth < 768 ? "12px" : "16px",
            }}
            >
            <span>Email</span>
            <FontAwesomeIcon icon={faEdit} className="editIcon" onClick={() => handleEditClick("email")} />
          </div>
          <div className="log-profile-details-box-side"  style={{ width: "100%" }}>{email}</div>
        </div>
        <div className="log-contact-option"  style={{ marginTop: "20px" }}>
          <div className="log-contact-label"  style={{
              fontSize: window.innerWidth < 768 ? "12px" : "16px",
            }}>
            <span>Contact Number</span>
            <FontAwesomeIcon icon={faEdit} className="editIcon" onClick={() => handleEditClick("contact")} />
          </div>
          <div className="log-profile-details-box-side" style={{ width: "100%" }}>{contactNumber}</div>
        </div>
        <p className="contact-note">
              <strong>Note:</strong> Changing your email will update your login
              credentials. Please use your new email to sign in.
            </p>

      </div>

      {isEmailPopupVisible && (
        <EditPopup title="Edit Email" fields={{ email }} onSave={handleSaveEmail} onClose={handleClosePopup} />
      )}
      {isContactPopupVisible && (
        <EditPopup title="Edit Contact Number" fields={{ contactNumber }} onSave={handleSaveContact} onClose={handleClosePopup} />
      )}

      {/* Alert Component */}
      <Alert openSnackbar={openSnackbar} alertSeverity={alertSeverity} setOpenSnackbar={setOpenSnackbar} alertMessage={alertMessage} />
    </div>
  );
};

export default EditEmail;
